import {
  createBaseAsyncHandlers,
  createFailAction,
  createStartAction,
  createSuccessAction,
  initialState,
} from '../../redux-util/async-helpers';
import { createReducer } from '../../redux-util/general-helpers';
import { CREATE_PAGE_VIEWER } from '../../redux-jigsaw/jigsaw-methods';
import { removeDuplicateValues } from '../../../utils/array';
import { LIST_ACTIVE_ASSETS } from '../bridge-method-remap';

const baseHandlers = createBaseAsyncHandlers(LIST_ACTIVE_ASSETS);

function doFetchStart(state, action) {
  const baseResult = baseHandlers[action.type](state, action);
  baseResult.data = state.data;
  return baseResult;
}

function doFetchSuccess(state, action) {
  const baseResult = baseHandlers[action.type](state, action);
  const oldBooks = state.data ? state.data.content || [] : [];
  // Account for items copied in from allBooks during reorderItems
  // that then get loaded into this list later
  const vbids = baseResult.data.content.map(d => d.vbid);
  const content = removeDuplicateValues(oldBooks.concat(vbids));
  baseResult.data = {
    ...baseResult.data,
    content,
  };
  return baseResult;
}

function doFetchFail(state, action) {
  return baseHandlers[action.type](state, action);
}

function reorderBooks(state, action) {
  let books = [];
  if (state.data && state.data.content) {
    books = [...state.data.content];
  }
  let updateContent = false;
  if (books.length > 0) {
    const index = books.indexOf(action.data.isbn);
    if (index > -1) {
      // Move the recently-opened book to the front of the list
      const book = books[index];
      books.splice(index, 1);
      books.unshift(book);
      updateContent = true;
    }
  }
  if (!updateContent) {
    // Put the book that was opened at the front of the list
    books.unshift(action.data.isbn);
    updateContent = true;
  }

  if (updateContent) {
    return {
      ...state,
      data: {
        ...state.data,
        content: books,
      },
    };
  }

  return state;
}

const fetchStart = createStartAction(LIST_ACTIVE_ASSETS).type;
const fetchSuccess = createSuccessAction(LIST_ACTIVE_ASSETS).type;
const fetchFail = createFailAction(LIST_ACTIVE_ASSETS).type;
const createViewer = createSuccessAction(CREATE_PAGE_VIEWER).type;

const extras = {
  [fetchStart]: doFetchStart,
  [fetchSuccess]: doFetchSuccess,
  [fetchFail]: doFetchFail,
  [createViewer]: reorderBooks,
};

export default createReducer(initialState, extras);
